import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=47a83f8d&scoped=true&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&id=47a83f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a83f8d",
  null
  
)

export default component.exports